(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.tabBar = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    props: {
      // 该属性废弃
      inkColor: {
        type: String,
        default: ''
      },
      // 该属性废弃
      // 配置后，maskStartShown、maskEndShown失效
      barBgColor: {
        type: String,
        default: ''
      },
      // 该属性废弃
      selectColor: {
        type: String,
        default: ''
      },
      // 该属性废弃
      unSelectColor: {
        type: String,
        default: ''
      },
      // 样式对象
      tabBarStyle: {
        type: Object,
        default: function _default() {
          return {
            barBgColor: '', // 配置后，maskStartShown、maskEndShown失效
            selectColor: '', // 选中项字体颜色
            unSelectColor: '', // 未选中项字体颜色
            inkColor: '' // 下划线颜色
          };
        }
      },
      // tab专用，吸顶时样式对象
      tabBarStyleAffixed: {
        default: function _default() {
          return {
            barBgColor: '', // 配置后，maskStartShown、maskEndShown失效
            selectColor: '', // 选中项字体颜色
            unSelectColor: '', // 未选中项字体颜色
            inkColor: '' // 下划线颜色
          };
        }
      }
    },
    // tab专用
    data: function data() {
      return {
        tabBarStyleData: this.tabBarStyle
      };
    }
  };
});